export default "__VITE_ASSET__D7Q9_D9X__"